import getEnv from '@/config/env';

import { parseQueryString } from './parseQueryString';

export const genApiUrl = () => {
  const { region: _region = 'us' } = parseQueryString();
  const region = _region.toUpperCase() as Uppercase<typeof _region>;

  const API_GATEWAY_URL = `https://api.${getEnv(`WEB_FORM_API_DOMAIN_${region}`)}`;
  const GEN_TOKEN_API_URL = `${API_GATEWAY_URL}/cm/core/web-forms/authorize`;
  const GET_API_URL = `${API_GATEWAY_URL}/cm/meta/web-forms`;
  const GET_CAPTCHA_API_URL = `${API_GATEWAY_URL}/cm/core/web-forms/captcha`;
  const POST_API_URL = `${API_GATEWAY_URL}/cm/core/web-forms`;

  return {
    API_GATEWAY_URL,
    GEN_TOKEN_API_URL,
    GET_API_URL,
    GET_CAPTCHA_API_URL,
    POST_API_URL,
  };
};
